import { render, staticRenderFns } from "./ProductArticleTexts.vue?vue&type=template&id=2250825b&scoped=true&"
import script from "./ProductArticleTexts.vue?vue&type=script&lang=ts&"
export * from "./ProductArticleTexts.vue?vue&type=script&lang=ts&"
import style0 from "./ProductArticleTexts.vue?vue&type=style&index=0&id=2250825b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2250825b",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VBtn,VContainer,VIcon})
